import { render, staticRenderFns } from "./SuscribeBar.vue?vue&type=template&id=67c24f42&"
import script from "./SuscribeBar.vue?vue&type=script&lang=js&"
export * from "./SuscribeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports